import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

customElements.define('k-trip-recent-posts', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
            margin-top: 4em;
        }

        :host([hidden]) {
            display: none;
        }

        .wp-block-cover {
            display: none;
        }

        b-details {
            display: contents;
            position: static;
        }

        :host > div {
            margin-bottom: 3em;
        }
    `

    constructor(){
        super()
        this.data = window.tripData?.recentTrips || []
        this.hidden = this.data.length == 0
    }

    render(){return html`
    
        <k-h2 color="blue">Recent trips</k-h2>
        <br>

        ${this.data.map((d,i)=>i>=3?html`
            
            <p><a href=${d.link}><b-text .html=${d.title}></b-text></a></p>

        `:html`

            <div>
                <k-h3 href=${d.link}><b-text .html=${d.title}></b-text></k-h3>
                ${unsafeHTML(d.content)}
            </div>
        `)}
    `}

})

export default customElements.get('k-trip-recent-posts')